import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Row, Spinner } from "reactstrap";
import requestIcon from "../../assets/img/DashboardIcons/requestIcon.svg";
import customersIcon from "../../assets/img/DashboardIcons/customersIcon.svg";
import cartIcon from "../../assets/img/DashboardIcons/cartIcon.svg";
import orderIcon from "../../assets/img/DashboardIcons/orderIcon.svg";
import dollarIcon from "../../assets/img/DashboardIcons/dollarIcon.svg";
import up from "../../assets/img/DashboardIcons/up.svg";
import down from "../../assets/img/DashboardIcons/down.png";
import { fetchRestaurantStats } from "store/actions/statsActions";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const DashboardCards = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { restaurantCurrency } = useSelector((state) => state.requests);

  const typeText =
    type === "day"
      ? "today"
      : type === "range"
      ? `in this ${type}`
      : `this ${type}`;

  const cardData = ({ stats, mappings, typeText, currency }) => {
    return mappings?.map(({ key, icon, name }) => ({
      card_no:
        key === "averageOrderSize"
          ? `${currency || ""} ${stats?.[key]?.total || 0}`
          : stats?.[key]?.total || 0,
      card_topIcon: icon,
      card_name: name,
      card_percent: `${stats?.[key]?.percentageChange || 0}% ${typeText}`,
      card_text: stats?.[key]?.change || 0,
      cardBottom_icon: stats?.[key]?.change || "",
    }));
  };

  const superAdminMappings = [
    { key: "customers", icon: customersIcon, name: "New Customers" },
    { key: "merchants", icon: cartIcon, name: "New Merchants" },
    { key: "churnRate", icon: orderIcon, name: "Churn Rate" },
    { key: "lifeTimeValue", icon: dollarIcon, name: "Life Time Value" },
  ];

  const restaurantMappings = [
    { key: "customers", icon: customersIcon, name: "New Customers" },
    { key: "orders", icon: cartIcon, name: "Total Orders" },
    { key: "averageOrderSize", icon: orderIcon, name: "Average Order Size" },
    { key: "requests", icon: requestIcon, name: "Requests" },
  ];

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : "",
  };

  const {
    data: statsData,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ["restaurantStats", payload],
    queryFn: () => dispatch(fetchRestaurantStats(payload)),
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true,
  });

  const typeBasedCardData = cardData({
    stats: statsData,
    mappings:
      user?.type === "restaurant" || merchant?.id
        ? restaurantMappings
        : superAdminMappings,
    typeText,
    currency: restaurantCurrency,
  });

  if (isError) {
    toast.error(error?.message || "Failed to load peak hours.");
  }

  return (
    <Card className="header-cards card overflow-hidden">
      <Row className="row">
        {isFetching ? (
          <Spinner color="primary" size="sm" className="mx-auto my-5" />
        ) : (
          typeBasedCardData.map((item, key) => (
            <Col xs={12} lg={6} xl={3} key={key} className="header-cards__col">
              <Card className="p-4 border-0 w-100">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="mb-0">{item?.card_no || 0}</h1>
                  <img src={item?.card_topIcon} alt="card icon" width={50} />
                </div>
                <span className="fs-14 mb-1 text-nowrap">
                  {item?.card_name}
                </span>
                <div className="d-flex justify-content-between align-items-center fs-12">
                  <div>
                    <img
                      src={item?.cardBottom_icon > 0 ? up : down}
                      alt="trend icon"
                    />
                    <span>{item?.card_text}</span>
                  </div>
                  <span>{item?.card_percent}</span>
                </div>
              </Card>
              <div className="divider"></div>
            </Col>
          ))
        )}
      </Row>
    </Card>
  );
};

export default DashboardCards;
